import React from 'react';
import { Input, InputNumber, Space } from 'antd';
import styles from '../../../event-timeline.module.css';

interface IncrementCounterParamsProps {
  params: any;
  setParams: (params: any) => void;
}

const IncrementCounterParams: React.FC<IncrementCounterParamsProps> = ({
  params,
  setParams,
}) => {
  return (
    <div className={styles.parameterContainer}>
      <Space direction='vertical' style={{ width: '100%' }}>
        <span>Counter ID:</span>
        <Input
          value={params.counterId || ''}
          onChange={(e) => setParams({ ...params, counterId: e.target.value })}
          placeholder='Enter counter ID'
        />
        <span>Value:</span>
        <InputNumber
          value={params.value || 1}
          onChange={(value) => setParams({ ...params, value })}
          style={{ width: '100%' }}
        />
      </Space>
    </div>
  );
};

export default IncrementCounterParams;
